import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import FilterSearch from 'pages/parts/FilterSearch'
import DeleteModal from 'pages/parts/DeleteModal'

import { findKeyFromArrayByValue, formatDate, returnSign } from "helpers/helpers";
import { httpOk, GET, DELETE } from 'helpers/api'

function Index() {
	const { t } = useTranslation()

	const reduxAccount = useSelector(state => state.account)

	const [data, setData] = useState({ data: [] })
	const [poses, setPoses] = useState([])
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({
		pos_id: reduxAccount.pos_id,
		search: '',
	})
	const [modalDelete, setModalDelete] = useState(false)
	const [modalDeleteAll, setModalDeleteAll] = useState(false)
	const [deleteModalParams, setDeleteModalParams] = useState({ product_id: null })

	async function searchWithFilter(nextFilterData = null) {
		var filterUrl = "/products/stop-list"
		var urlParams = ""
		checkFilter()
		const currentFilterData = nextFilterData || filterData

		if (currentFilterData.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + currentFilterData.pos_id
		if (currentFilterData.search)
			urlParams += returnSign(urlParams) + 'search=' + currentFilterData.search
		if (currentFilterData.page)
			urlParams += returnSign(urlParams) + 'page=' + currentFilterData.page

		if (`/products/stop-list${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data)

		setDropdownIsOpen(false)
	}

	function handleSearchChange(search) {
		const nextFilterData = { ...filterData, search, page: null }
		setFilterData(nextFilterData)
		searchWithFilter(nextFilterData)
	}

	function resetFilter() {
		const nextFilterData = {
			pos_id: reduxAccount.pos_id,
			search: '',
		}
		setFilterData(nextFilterData)
		setFilterDataExist(false)
		searchWithFilter(nextFilterData)
	}

	function checkFilter() {
		if (
			filterData.pos_id === null &&
			filterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function getPoses() {
		const response = await GET('/helper/poses', {}, { loader: true })
		if (httpOk(response)) setPoses(response.data)
	}

	function openDeleteModal(item) {
		setDeleteModalParams({ product_id: item.product_id })
		setModalDelete(true)
	}

	async function deleteItem() {
		const response = await DELETE(
			`/products-stop-list/${deleteModalParams.product_id}`,
			{ pos_id: filterData.pos_id },
			{ loader: true }
		)
		if (httpOk(response)) {
			setModalDelete(false)
			searchWithFilter()
		}
	}

	async function deleteAll() {
		const response = await DELETE(
			'/products-stop-list-all',
			{ pos_id: filterData.pos_id },
			{ loader: true }
		)
		if (httpOk(response)) {
			setModalDeleteAll(false)
			searchWithFilter()
		}
	}

	useEffect(() => {
		getPoses()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('online_stop_list')} [{data?.data?.length || 0}]
				</h4>
				{(data?.data?.length > 0) &&
					<button className="btn btn-danger"
						onClick={() => setModalDeleteAll(true)}>
						{t('delete_all')}
					</button>
				}
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									value={filterData.search}
									onSearchChange={handleSearchChange}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('pos')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.pos_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'pos_id': option.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary"
														onClick={() => setDropdownIsOpen(false)}>
														{t('cancel')}
													</button>
													<button className="btn btn-primary"
														onClick={() => searchWithFilter()}>
														{t('apply')}
													</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{filterData.pos_id &&
									<span className="me-2">
										<b>{t('pos')}: </b>
										{findKeyFromArrayByValue(poses, 'id', filterData.pos_id, 'name')}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'width': '33px', 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '35%' }}>{t('name2')}</th>
									<th style={{ 'width': '20%' }} className="text-center">{t('employee')}</th>
									<th style={{ 'minWidth': '115px' }} className="text-center">{t('created')}</th>
									<th style={{ 'width': '15%' }} className="text-end">{t('quantity')}</th>
									<th style={{ 'width': '33px', 'minWidth': '33px' }} className="text-center"></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={item.product_id || index}>
										<td className="text-center">{index + 1}</td>
										<td className="td-ellipsis">{item.name}</td>
										<td className="td-ellipsis text-center">{item.employee_name}</td>
										<td className="td-ellipsis text-center">{formatDate(item.created_at, 'dd.MM.yy HH:mm')}</td>
										<td className="text-end">{item.quantity}</td>
										<td className="text-center">
											<div className="table-action-button table-action-danger-button"
												onClick={() => openDeleteModal(item)}>
												<i className="uil-times"></i>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}
			/>
			<DeleteModal
				modalDelete={modalDeleteAll}
				setModalDelete={setModalDeleteAll}
				deleteItem={deleteAll}
				message={t('are_you_sure_you_want_delete')}
			/>
		</>
	)
}

export default Index
